import SubscriptionSalvage from 'components/subcriptionSalvage';

const SubscriptionSalvagePage = () => {
  return <SubscriptionSalvage />;
};

export default SubscriptionSalvagePage;
